export const List = ({steps}) => {
  return (
    <ul className="space-y-4 md:space-y-24">
          {steps.map((step, index) => {
            const isLast = index === steps.length - 1

            return (
              <li key={index} className="relative pl-12">
                {/* Dot or Checkmark */}
                <div
                  className={`absolute left-0 -top-1 flex items-center justify-center text-xs font-bold`}
                >
                  <img src="/star.svg" alt="" className='w-8 h-8' />
                </div>

                {/* Label */}
                <div
                  className={`text-base leading-5 text-[#fff] font-oxanium`}
                >
                  {step.label}
                </div>

                {/* Vertical Line */}
                {!isLast && (
                  <div
                    className={`hidden md:block absolute left-4 top-11 h-14 border-r-2 border-dashed border-[#ddd]`}
                  />
                )}
              </li>
            )
          })}
        </ul>
  )
}
